import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-prescription",
  "use": "icon-prescription-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-prescription\"><defs><style type=\"text/css\"></style></defs><path d=\"M801.18 143.254c114.603 91.493 134.59 259.458 44.393 374.534l-250.65 319.714c-43.591 55.725-106.558 90.994-176.752 99.032-70.22 7.995-139.518-12.106-195.115-56.466-55.531-44.367-90.726-107.741-99.123-178.453l-0.98-9.617c-5.651-67.266 13.939-133.224 55.575-186.447l122.896-156.902 0.842-1.336 1.629-1.822 5.303-6.735 119.964-153.01c43.647-55.794 106.626-91.098 176.798-99.045 70.414-7.949 139.747 12.133 195.22 56.553zM427.426 378.137c-17.58-14.236-43.373-11.526-57.609 6.055-14.236 17.58-11.525 43.372 6.055 57.609l233.434 189.03c17.58 14.237 43.373 11.526 57.609-6.054 14.236-17.58 11.525-43.373-6.055-57.61z\" p-id=\"1945\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/prescription.svg
// module id = BzLY
// module chunks = 11